import React from 'react';
import icon1 from '../../../icons/audit-1.svg';
import icon2 from '../../../icons/audit-2.svg';
import icon3 from '../../../icons/audit-3.svg';
import icon4 from '../../../icons/audit-4.svg';
import icon5 from '../../../icons/audit-5.svg';
import icon6 from '../../../icons/audit-6.svg';
import icon7 from '../../../icons/audit-7.svg';

const ICONS = [icon1, icon2, icon3, icon4, icon5, icon6, icon7];

const AuditIcon = ({ index, alt }) => (
    <img
        className="audit-step-icon"
        src={ICONS[index]}
        alt={alt || `Этап ${index + 1}`}
    />
);

export default AuditIcon;
